import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PanelLeft24Regular, PanelRight24Regular } from '@fluentui/react-icons';
import { 
  MdWavingHand,
  MdWorkspaces,
} from 'react-icons/md';
import { RiCustomerService2Line } from 'react-icons/ri';
import { FaWpforms } from 'react-icons/fa';
import { BiGitMerge } from 'react-icons/bi';
import './CSS/NodesPalette.css';

/**
 * NodesPalette - Panel gauche avec liste des nœuds disponibles
 */
const NodesPalette = ({ chatFlowData }) => {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState('generale');
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showCategoryMenu, setShowCategoryMenu] = useState(false);

  // Vérifier si le greeting existe déjà
  const greeting = chatFlowData?.greeting || {};
  const hasGreeting = Object.entries(greeting).some(([key, msg]) => msg?.enabled);

  // Map des icônes par node ID
  const nodeIcons = {
    'greeting': MdWavingHand,
    'queue': RiCustomerService2Line,
    'customer-choice': BiGitMerge,
    'form': FaWpforms,
    'trigger': MdWorkspaces,
  };

  const categories = [
    {
      id: 'generale',
      label: t('GENERAL'),
      nodes: [
        { id: 'greeting', title: t('GREETING_MESSAGE'), description: t('GREETING_MESSAGES_DESCRIPTION') },
      ],
    },
    {
      id: 'routing',
      label: t('ROUTING'),
      nodes: [
        { id: 'queue', title: t('QUEUE'), description: t('QUEUE_DESCRIPTION') },
        { id: 'customer-choice', title: t('CUSTOMER_CHOICE'), description: t('CUSTOMER_CHOICE_DESCRIPTION') },
        { id: 'form', title: t('FORM'), description: t('FORM_DESCRIPTION') },
      ],
    },
   
  ];

  const currentNodes = categories.find((cat) => cat.id === activeCategory)?.nodes || [];

  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className={`nodes-palette-wrapper ${isCollapsed ? 'collapsed' : ''}`}>
      <aside className="nodes-palette-container">
        {/* Bouton collapse/expand en haut à droite */}
        <div className='palette-header-toggle' >
        <button
          className="palette-toggle-btn-top"
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? t('SHOW_PANEL') : t('HIDE_PANEL')}
        >
          {isCollapsed ? <PanelRight24Regular /> : <PanelLeft24Regular />}
        </button>
        </div>
        {/* Onglets de catégories */}
        <div className="palette-categories">
          {/* Mode normal : onglets horizontaux */}
          {categories.map((category, index) => (
            <button
              key={category.id}
              className={`category-tab ${activeCategory === category.id ? 'active' : ''} ${isCollapsed && index > 0 ? 'hidden-collapsed' : ''}`}
              onClick={() => {
                if (isCollapsed && index === 0) {
                  setShowCategoryMenu(!showCategoryMenu);
                } else {
                  setActiveCategory(category.id);
                }
              }}
            >
              {category.label}
            </button>
          ))}

          {/* Popup menu en mode collapsed */}
          {isCollapsed && showCategoryMenu && (
            <div className="category-popup-menu">
              {categories.map((category) => (
                <button
                  key={category.id}
                  className={`category-popup-item ${activeCategory === category.id ? 'active' : ''}`}
                  onClick={() => {
                    setActiveCategory(category.id);
                    setShowCategoryMenu(false);
                  }}
                >
                  {category.label}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Liste des nœuds */}
        <div className="palette-nodes-list">
          {currentNodes.map((node) => {
            const IconComponent = nodeIcons[node.id];
            const isDisabled = node.id === 'greeting' && hasGreeting;
            
            return (
              <div
                key={node.id}
                className={`palette-node-item ${isDisabled ? 'disabled' : ''}`}
                draggable={!isDisabled}
                onDragStart={(e) => !isDisabled && onDragStart(e, node.id)}
                title={isDisabled ? t('GREETING_ALREADY_ADDED') : node.description}
              >
                <div className="node-item-content">
                  {IconComponent && <IconComponent className="node-item-icon" size={20} />}
                  <div className="node-item-description">{node.title}</div>
                </div>
              </div>
            );
          })}
        </div>
      </aside>
    </div>
  );
};

export default NodesPalette;
